import React, { useState } from "react";
import ImageAndInitialViewer from "../../../../molecules/ImageAndInitialViewer";
import moment from "moment";
import ImageModal from "../../../../organisms/modals/ImageModal";
import { convertUtcToLocalTime } from "../../../../../helpers/convertUtcToLocalTime";

const CheckInCard = ({ item, type }) => {
  const [image, setImage] = useState({
    isActive: null,
    image: null,
  });


  
  const handleImage = (image) => {
    if (image) {
      setImage({
        isActive: true,
        image: image,
      });
    }
  };


  return (
    <>
      <div className="dashboard__info__modal checked__in__card">
        <div
          onClick={() => handleImage(item?.check_in_photo)}
          className={item?.check_in_photo ? "cursor-pointer" : ""}
        >
          <ImageAndInitialViewer image={item.check_in_photo} name={item.name} />
        </div>
        <div className="details">
          <h6
            className="list-group-item-heading"
            onclick="showEmployeeDetail(947)"
          >
            {item.name}{" "}
            {item.additional_visitor_count > 0 ?
              `+${item.additional_visitor_count}` : null}
            <span class="font-small-3 float-right dark-blue">
              {" "}
              {type === "checkin"
                ? item?.check_in_time
                  ? moment(item?.check_in_time).format("h:mm A")
                  : null
                : item?.check_out_time
                ? `${moment(item?.check_in_time).format("h:mm A")} / ${moment(
                    item?.check_out_time
                  ).format("h:mm A")}`
                : null}
            </span>
          </h6>
          <p className="list-group-item-text text-muted ">
            {item.contact_no === null ? item.email : item.contact_no}

            {/* {moment(item?.date).format("DD/MM/YYYY")} */}
            <span className="float-right dark-blue">
              {item?.check_in_time && item?.check_out_time
                ? moment(item.check_in_time).format("DD/MM/YYYY") ===
                  moment(item.check_out_time).format("DD/MM/YYYY")
                  ? moment(item.check_in_time).format("DD/MM/YYYY")
                  : `${moment(item.check_in_time).format(
                      "DD/MM/YYYY"
                    )} - ${moment(item.check_out_time).format("DD/MM/YYYY")}`
                : item?.check_in_time
                ? moment(item.check_in_time).format("DD/MM/YYYY")
                : item?.check_out_time
                ? moment(item.check_out_time).format("DD/MM/YYYY")
                : null}
            </span>
          </p>
        </div>
      </div>
      <hr style={{ borderTop: "1px solid #efefef", opacity: 1 }} />

      {image?.isActive && (
        <ImageModal
          isActive={image?.isActive}
          setIsActive={setImage}
          image={image?.image}
        />
      )}
    </>
  );
};

export default CheckInCard;
